export function getOpenAccountButtons() {
    return $<HTMLButtonElement>('.js-header-show-hide-email, #header_user_info, #account_button');
}
